// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1628":"a4295891fc25aa2d","2888":"758620a37fcf1b9e"}[chunkId] + ".css";
};